import './ContainerCard.css'

const ContainerCard = ( {img, title, description})=>{
return(
    <div className="containerCard">
        <img src={img} alt={title}  className="imgCard"/>
        <p className="titleCard">{title}</p>
        <p className="descriptionCard">{description}</p>
    </div>
)
}

export default ContainerCard